import englishMessages from "ra-language-english";
import {
  ACS_EXTERNAL_USER,
  ACS_INTERNAL_ADMIN,
  ACS_INTERNAL_DOCUMENT_VIEWER,
  ACS_INTERNAL_EDITOR,
  ACS_INTERNAL_VIEWER,
  ACS_ORG_ADMIN,
  ACS_ORG_EDITOR,
  ACS_ORG_VIEWER,
  DANDE_EXTERNAL_USER,
  DANDE_INTERNAL_ADMIN,
  DANDE_INTERNAL_EDITOR,
  DANDE_INTERNAL_USER,
  DANDE_INTERNAL_VIEWER,
  DANDE_ORG_ADMIN,
  DANDE_ORG_EDITOR,
  DANDE_ORG_VIEWER,
  ER_EXTERNAL_USER,
  ER_INTERNAL_ADMIN,
  ER_INTERNAL_EDITOR,
  ER_INTERNAL_VIEWER,
  ER_ORG_ADMIN,
  ER_ORG_EDITOR,
  ER_ORG_VIEWER,
  NZGB_EXTERNAL_USER,
  NZGB_INTERNAL_ADMIN,
  NZGB_INTERNAL_VIEWER,
  POCP_EXTERNAL_USER,
  POCP_INTERNAL_ADMIN,
  POCP_INTERNAL_EDITOR,
  POCP_INTERNAL_VIEWER,
  POCP_ORG_ADMIN,
  POCP_ORG_EDITOR,
  POCP_ORG_VIEWER,
} from "../constants";

export const portalMessages = {
  ...englishMessages,
  [ER_ORG_ADMIN]: "Admin",
  [ER_ORG_VIEWER]: "View",
  [ER_ORG_EDITOR]: "Edit",
  [ER_EXTERNAL_USER]: "External AUFLS User",
  [ER_INTERNAL_VIEWER]: "Transpower AUFLS Viewer",
  [ER_INTERNAL_EDITOR]: "Transpower AUFLS Editor",
  [ER_INTERNAL_ADMIN]: "Transpower AUFLS Admin",
  [ACS_ORG_ADMIN]: "Admin",
  [ACS_ORG_VIEWER]: "View",
  [ACS_ORG_EDITOR]: "Edit",
  [ACS_EXTERNAL_USER]: "External ACS User",
  [ACS_INTERNAL_VIEWER]: "Transpower ACS Viewer",
  [ACS_INTERNAL_EDITOR]: "Transpower ACS Editor",
  [ACS_INTERNAL_ADMIN]: "Transpower ACS Admin",
  [ACS_INTERNAL_DOCUMENT_VIEWER]: "ACS Document Access",
  [`short_${ACS_INTERNAL_VIEWER}`]: "View",
  [`short_${ACS_INTERNAL_EDITOR}`]: "Edit",
  [`short_${ACS_INTERNAL_ADMIN}`]: "Admin",
  [`short_${ACS_INTERNAL_DOCUMENT_VIEWER}`]: "Document Access",
  [POCP_ORG_ADMIN]: "Admin",
  [POCP_ORG_VIEWER]: "View",
  [POCP_ORG_EDITOR]: "Edit",
  [POCP_EXTERNAL_USER]: "External POCP User",
  [POCP_INTERNAL_VIEWER]: "Transpower POCP Viewer",
  [POCP_INTERNAL_EDITOR]: "Transpower POCP Editor",
  [POCP_INTERNAL_ADMIN]: "Transpower POCP Admin",
  [`short_${POCP_INTERNAL_VIEWER}`]: "View",
  [`short_${POCP_INTERNAL_EDITOR}`]: "Edit",
  [`short_${POCP_INTERNAL_ADMIN}`]: "Admin",
  [NZGB_EXTERNAL_USER]: "External NZGB User",
  [NZGB_INTERNAL_VIEWER]: "Transpower NZGB Viewer",
  [NZGB_INTERNAL_ADMIN]: "Transpower NZGB Admin",
  [`short_${NZGB_INTERNAL_VIEWER}`]: "View",
  [`short_${NZGB_INTERNAL_ADMIN}`]: "Admin",
  [DANDE_ORG_ADMIN]: "Admin",
  [DANDE_ORG_VIEWER]: "View",
  [DANDE_ORG_EDITOR]: "Edit",
  [DANDE_EXTERNAL_USER]: "External SO Register User",
  [DANDE_INTERNAL_USER]: "Internal SO Register User",
  [DANDE_INTERNAL_VIEWER]: "Transpower SO Register Viewer",
  [DANDE_INTERNAL_EDITOR]: "Transpower SO Register Editor",
  [DANDE_INTERNAL_ADMIN]: "Transpower SO Register Admin",
  [`short_${DANDE_EXTERNAL_USER}`]: "External User",
  [`short_${DANDE_INTERNAL_USER}`]: "Internal User",
  [`short_${DANDE_INTERNAL_VIEWER}`]: "Internal Viewer",
  [`short_${DANDE_INTERNAL_EDITOR}`]: "Internal Editor",
  [`short_${DANDE_INTERNAL_ADMIN}`]: "Internal Admin",

  portal: {
    contact: "SO_customer_portal@transpower.co.nz",
    name: "Customer Portal",
    subject: "Customer Portal Query",
    error: {
      noOrgMembershipInApp:
        "You are not yet a member of an organisation in the %{appname} application.",
      noOrgMembershipHelp:
        "Please talk to the administrator for your organisation to be setup with the correct permissions.",
      noAuthorisation:
        "Sorry, but you don't have permission to access this part of the %{appname} application.",
      noAuthorisationHelp:
        "If you believe you should already have access, please contact the Administrator of this application.",
      noMatchingConfirmationField:
        "The confirmation value for %{field} doesn't match.",
      noAppAccess:
        "Sorry, but you don't have permission to access this application.",
      noAppAccessHelp:
        "If you believe you should have access, please contact the System Operator Administrator using ",
      emailConfirmError: "The confirmation email does not match",
      loginFailedNoPermission:
        "Sorry, you don't have permission to log in to this application.",
      loginFailedWithError: "An error occured while attempting to log in.",
    },
    dialog: {
      confirm: "Please Confirm",
      confirmUserTitle: "New user creation confirmation.",
      confirmUserMessage:
        "Please enter the email address of the user to confirm:",
      confirmPrompt: "Please type 'confirm' to continue",
      confirmDeleteTitle: "Delete confirmation",
      confirmDeleteContent: "Are you sure you want to delete this item?",
      confirmOrgCreate: "New organisation creation confirmation.",
      confirmOrgCreateContent:
        "Are you sure you want to create a new organisation? Once created organisations cannot be deleted. The organisation name, participant code and participant type can be edited.",
      confirmOrgEdit: "Update organisation confirmation.",
      confirmOrgEditContent:
        "Are you sure you want to update this organisation? Please note that changes to the organisation name or participant code may affect other integrations.",
      changeRole: "Change user role",
    },
    messages: {
      userCreateFailed: "User could not be created",
      userCreateOK: "User successfully created or updated",
      orgUserCreateOK: "User account creation request submitted",
      orgUserEditOK: "User permissions updated",
      orgUserEditFailed: "Could not update user permissions",
      cancelled: "Cancelled",
      assetRemoved: "Asset Removed",
      serverError: "A server error occurred",
      serverErrorUpload:
        "A server error occurred while processing an uploaded file",
      contactTranspower:
        "For general website questions or problems you can contact Transpower at ",
      created: "Item created successfully",
      orgCreated: "Organisation created",
      orgUpdated: "Organisation updated",
      userRemovedFromOrg: "User removed from organisation",
      userExportError:
        "Error while exporting Users. Please try again or contact Transpower",
    },
    action: {
      orgCreate: "Create new organisation",
      orgCreateUser: "Request to add new user",
      orgEditUser: "Manage Permissions",
      gotoApp: "GO TO %{appName}",
      login: "LOGIN",
    },
    page: {
      orgCreateUser: "Request new user for %{orgName}",
      orgUserList: "Users for %{orgName}",
      orgUserEdit: "Manage user permissions",
      orgCreate: "Add new organisation",
      edit: "Update %{name}",
    },
    title: {
      noauth: "Not Authorised",
      contactTranspower: "Contact Transpower",
      customerPortal: "Operations Customer Portal",
      participant: "Organisations",
    },
    menu: {
      portalAdmin: "Portal Management",
    },
    label: {
      appPermission: "Application Permission",
      orgPermission: "User Permission",
      lastAccessed: "Last Log In",
      fullname: "Full Name",
      partType: "Participant Type",
      partCode: "Participant Code",
      orgName: "Organisation Name",
      participant: {
        None: "None",
        Guest: "Guest",
        Distributor: "Distributor",
        DirectConnect: "Direct Connect",
        Generator: "Generator",
        GridOwner: "Grid Owner",
        Trader: "Trader",
      },
      notLoggedIn: "You are not logged in",
      helperText: {
        fourLetterCode: "Must be a 4 letter code, or blank.",
        participant: {
          None:
            "An organisation that is not considered a participant as defined by the Electricity Authority.",
          Distributor:
            "A business engaged in distribution, which is the conveyance of electricity on lines other than lines that are part of the national grid.",
          DirectConnect:
            "A consumer with a point of connection to the grid who is supplied electricity for consumption not resupply.",
          Generator:
            "A business/person engaged in generation who owns generating units connected to a the grid, a local network, or an embedded network. Or any business/person who acts on behalf of any business/person who owns such generating units.",
          Trader: "A participant in the wholesale market.",
        },
      },
    },
    register: {
      contentTitle: "Register as a user",
      contentDescription: {
        main:
          "Use this form to request a registered user account. A registered user account allows access to further customer portal functionality such as:",
        pocp:
          "Saved searches, outage change notifications and SO assessment reports in POCP.",
        nzgb: "Detailed generation balance data on NZGB.",
        soregister:
          "Make submissions towards draft decisions for dispensations or equivalence arrangements in SO Register.",
        main2:
          "The registration request will be sent to Transpower for review and fulfilment.",
        note:
          "Note: If you are associated with a New Zealand electricity industry asset owner (for example a generator or distribution company), please request access from your organisation’s POCP, NZGB or SO Register asset owner administrator.",
      },
      contact: {
        text: "For any queries, please get in touch at ",
        email: "SO_customer_portal@transpower.co.nz",
        subject: "Customer portal user registration query",
      },
      label: {
        organisation: "Organisation",
      },
    },
    validation: {
      isEqualTo: "Must be equal to %{expected}",
      lessThan: "Must be less than %{max}",
      lessThanOrEqualTo: "Must be less than or equal to %{max}",
      greaterThan: "Must be greater than %{min}",
      greaterThanOrEqualTo: "Must be greater than or equal to %{min}",
      between:
        "The range of values that are expected is %{min} - %{max}, please confirm the value is correct if outside this range",
      startDateBlank: "Must enter a start date",
      endDateMustLaterThanStartDate: "End date must be later than start date.",
    },
    input: {
      emailConfirm: "Email confirmation",
    },
    notification: {
      disabledTooltip:
        "You have unsaved changes which are preventing you from completing this action.",
      disabledSaveButton:
        "Your form is either missing mandatory fields or has no unsaved changes which are preventing you from saving this form.",
    },
  },
};
